import {makeStyles} from "tss-react/mui";
import {Box, CircularProgress, Typography} from "@mui/material";
import MyCoursesSlider from "@/app2/components/myCoursesSlider/MyCoursesSlider";
import {palette} from "@/constants";
import {useActiveCourses} from "./hooks";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	loadingContainer: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		height: "160px",
		flexDirection: "column",
		border: "1px solid " + palette.grey08,
		borderRadius: "16px",
		background: "#282828"
	},
	coursesContainer: {
		display: "flex",
		flexDirection: "column",
		gap: "20px"
	},
	noCoursesFoundContainer: {
		padding: "15px",
		display: "flex",
		boxSizing: "border-box",
		width: "100%",
		flexDirection: "column",
		border: "1px solid " + palette.grey08,
		borderRadius: "16px",
		background: "#282828"
	}
}));

export const MyCourses: React.FC = () => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const {courses, isLoading} = useActiveCourses();

	return (
		<>
			{isLoading && <div className={classes.loadingContainer}><CircularProgress color="secondary" /></div>}
			{!isLoading && courses.length === 0 && <Box className={classes.noCoursesFoundContainer}><Typography>{t("no_courses_found", "No Courses Found")}</Typography></Box>}
			<Box className={classes.coursesContainer}>
				{courses.map((course: any) => (
					<MyCoursesSlider key={course.id} course={course} />
				))}
			</Box>
		</>
	);
}
